export default "__VITE_ASSET__BeSL3U0K__"